export default {
  totalValueSelectcredit: state => {
    let value = 0.0 
    state.select['credit'].selected.forEach(element => {
      value += element.value
    })
    return value.toFixed(2)
  }
}
